import React from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowLeft, UserRound } from "lucide-react";
import { useB2C } from "@/context/B2CAuthContext";
import { FormHeader, StepProgress } from "@/components/FormShell";
import { AuthForms } from "@/pages/b2c/MonCompte";
import { Button } from "@/components/ui/button";

const SLIDE = {
  initial: { opacity: 0, x: 48, filter: "blur(4px)" },
  animate: { opacity: 1, x: 0, filter: "blur(0px)" },
  exit: { opacity: 0, x: -48, filter: "blur(4px)" },
  transition: { duration: 0.38, ease: [0.22, 1, 0.36, 1] },
};

// Animated wizard container: each `view` slides/fades in place, no page reload.
export const WizardViews = ({ view, children }) => (
  <AnimatePresence mode="wait" initial={false}>
    <motion.div key={view} {...SLIDE} data-testid={`wizard-view-${view}`}>{children}</motion.div>
  </AnimatePresence>
);

// Step 2 of the declaration wizard: the existing B2C login / sign-up form, inline.
export const WizardAuthStep = ({ t, icon, title, subtitle, labels, onBack, testid = "wizard-auth-step" }) => {
  const { login, register } = useB2C();
  return (
    <div className="space-y-6" data-testid={testid}>
      <div className="findo-form form-card bg-white rounded-3xl border border-border overflow-hidden">
        <FormHeader icon={icon || UserRound} title={title} subtitle={subtitle} testid={`${testid}-header`}>
          <StepProgress step={2} total={3} labels={labels} t={t} />
        </FormHeader>
      </div>
      <AuthForms login={login} register={register} t={t} />
      <Button type="button" variant="ghost" onClick={onBack} className="w-full h-11 rounded-xl font-semibold text-findo-navy" data-testid={`${testid}-back`}>
        <ArrowLeft size={16} className="mr-1.5" /> {t("form.back")}
      </Button>
    </div>
  );
};
